import React from "react";
import moment from "moment";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Label,
  Input,
  FormGroup,
} from "reactstrap";
import firebase from "../../../Firebase.js";
import { Upload, Icon, notification, message, DatePicker, Button } from "antd";
import Select from "react-select";
import locale from "antd/es/date-picker/locale/es_ES";
import "react-datepicker/dist/react-datepicker.css";
import { handleChangeSwift, customUploadSwift } from "services";
import "./EditComercialRegister.scss";

class EditComercialRegister extends React.Component {
  constructor() {
    super();
    this.ref = firebase.firestore().collection("comercial");
    this.storageRef = firebase.storage();
    this.state = {
      fechaIngreso: new Date(),
      fechaEntrega: new Date(),
      oldFechaIngreso: null,
      oldFechaEntrega: null,
      oldProf: null,
      oldCliente: null,
      prof: "",
      isOpen2: false,
      doc: "",
      clientes: [],
      selectedOption: null,
      imgProf: "",
      imgProfsp: "",
      data: null,
      cliente: null,
      profor: null,
      pcpvalue: "",
      isActive: false,
      fpSinPrecioURL: null,
      proforma: [],
      loading: false,
      selectedFile: null,
      selectedFileList: [],
      pdfUrl: "",
      filelistVenta: null,
      filelistProd: null,
      fileListVentas: null,
      fileListProduc: null,
      uploading: false,
      swifts: [],
    };
  }

  componentDidMount() {
    if (!this.props.location.state) return;
    const {
      doc,
      prof,
      a,
      profsp,
    } = this.props.location.state;
    
    // Fallback for doc to avoid null strings
    const docId = String(doc);
    const pdfVenta = a;
    const pdfProd = profsp;
    const pfAnterior = prof;

    firebase
      .firestore()
      .collection("comercial")
      .orderBy("order", "asc")
      .get()
      .then((querySnap) => {
        const prof = [];
        const swf30 = [];
        const swf70 = [];
        querySnap.forEach((doc) => {
          if (doc.data().prof) {
            prof.push(doc.data().prof);
          }
          if (doc.data().sw30) {
            swf30.push(doc.data().sw30);
          }
          if (doc.data().sw70) {
            swf70.push(doc.data().sw70);
          }
        });
        this.setState({
          proforma: prof,
          wift30file: swf30,
          swift70file: swf70,
        });
      });

    firebase
      .firestore()
      .collection("ing")
      .where("prof", "==", prof)
      .get()
      .then((querySnapshot) => {
        let pcpvalue = null;
        querySnapshot.forEach((doc) => {
          pcpvalue = doc.data().index;
        });
        this.setState({ pcpvalue });
      });

    firebase
      .firestore()
      .collection("clientes")
      .get()
      .then((querySnapshot) => {
        var clientes = [];
        querySnapshot.forEach(function(doc) {
          clientes.push({
            label: doc.data().name,
            value: doc.id,
          });
        });
        this.setState({ clientes: clientes });
      });

    function arraymove(arr, fromIndex, toIndex) {
      var element = arr[fromIndex];
      arr.splice(fromIndex, 1);
      arr.splice(toIndex, 0, element);
      return arr;
    }

    this.ref
      .doc(docId)
      .get()
      .then((doc) => {
        if (!doc.exists) return;
        const dataComercial = doc.data();

        const fechaIngreso = new Date(
          arraymove(dataComercial.cFechaIngreso.split("/"), 0, 1).join("/")
        );
        const fechaEntrega = new Date(
          arraymove(dataComercial.cFechaEntrega.split("/"), 0, 1).join("/")
        );
        let selectedOption = { label: dataComercial.cliente, value: dataComercial.cliente };

        // Refined Priority Loading Logic (Merging Legacy + Dynamic)
        let swifts = dataComercial.swifts && Array.isArray(dataComercial.swifts) ? [...dataComercial.swifts] : [];

        // Slot 0 Priority (Legacy 30%)
        if (dataComercial.sw30Files && dataComercial.sw30Files[0] && (!swifts[0] || !swifts[0].url)) {
          const legacy0 = {
            name: "SWIFT 1",
            url: dataComercial.sw30Files[0],
            fileList: [{
              uid: 'legacy-30',
              name: "SWIFT 1",
              status: 'done',
              url: dataComercial.sw30Files[0]
            }]
          };
          if (swifts.length > 0) swifts[0] = legacy0; else swifts.push(legacy0);
        }

        // Slot 1 Priority (Legacy 70%)
        if (dataComercial.sw70Files && dataComercial.sw70Files[0] && (!swifts[1] || !swifts[1].url)) {
          const legacy1 = {
            name: "SWIFT 2",
            url: dataComercial.sw70Files[0],
            fileList: [{
              uid: 'legacy-70',
              name: "SWIFT 2",
              status: 'done',
              url: dataComercial.sw70Files[0]
            }]
          };
          // Ensure slot 0 exists if slot 1 is being patched
          if (swifts.length === 0) {
            swifts.push({ name: 'SWIFT 1', url: '', fileList: [] });
          }
          if (swifts.length > 1) swifts[1] = legacy1; else swifts.push(legacy1);
        }

        // Standardize fileList for all items
        swifts = swifts.map((s, idx) => ({
          ...s,
          fileList: s.fileList || (s.url ? [{
            uid: `swift-${idx}`,
            name: s.name || `SWIFT ${idx + 1}`,
            status: 'done',
            url: s.url
          }] : [])
        }));

        // Default to one empty if none found
        if (swifts.length === 0) {
          swifts.push({ name: 'SWIFT 1', url: '', fileList: [] });
        }

        this.setState({
          data: dataComercial,
          doc: docId,
          prof: pfAnterior,
          selectedOption,
          fechaIngreso,
          fechaEntrega,
          oldFechaEntrega: fechaEntrega,
          oldFechaIngreso: fechaIngreso,
          oldCliente: dataComercial.cliente,
          oldProf: pfAnterior,
          swifts,
          pdfVenta,
          pdfProd,
          fileListVentas: [
            {
              uid: docId,
              name: pfAnterior,
              status: "done",
              url: pdfVenta,
            },
          ],
          fileListProduc: [
            {
              uid: docId,
              name: pfAnterior,
              status: "done",
              url: pdfProd,
            },
          ],
        });
      });
  }

  handleChange = (date) => {
    this.setState({
      fechaIngreso: date,
    });
  };

  handleChange2 = (date) => {
    this.setState({
      fechaEntrega: date,
    });
  };

  selectHandleChange = (selectedOption) => {
    this.setState({ selectedOption });
  };

  addSwift = () => {
    const { swifts } = this.state;
    this.setState({
      swifts: [
        ...swifts,
        { name: `SWIFT ${swifts.length + 1}`, url: "", fileList: [] },
      ],
    });
  };

  removeSwift = (index) => {
    const { swifts } = this.state;
    if (swifts.length > 1) {
      const newSwifts = swifts.filter((_, i) => i !== index);
      // We do NOT rename existing files to preserve original filenames 
      // when users upload a file and then delete another slot.
      this.setState({ swifts: newSwifts });
    }
  };

  handleSwiftChange = (index, info) => {
    const { swifts } = this.state;
    const newSwifts = [...swifts];
    
    let fileList = [...info.fileList];
    if (fileList.length > 1) {
      fileList.splice(0, 1);
    }
    
    fileList = fileList.map(file => {
      if (file.response) {
        file.url = file.response.url;
      }
      return file;
    });

    newSwifts[index].fileList = fileList;
    if (fileList.length > 0 && fileList[0].status === 'done') {
      newSwifts[index].url = fileList[0].url || fileList[0].xhr?.url;
      // Set name to original filename from the file object
      newSwifts[index].name = fileList[0].name;
    } else if (fileList.length === 0) {
      newSwifts[index].url = "";
    }

    this.setState({ swifts: newSwifts });

    if (info.file.status === "uploading") {
      this.setState({ loading: true });
    } else {
      this.setState({ loading: false });
    }
  };

  onChange = (e) => {
    const state = this.state;
    state[e.target.name] = e.target.value;
    this.setState(state);
  };

  onSubmit = async (e) => {
    e.preventDefault();
    const {
      fechaIngreso,
      fechaEntrega,
      doc,
      prof,
      selectedOption,
      pcpvalue,
      proforma,
      oldProf,
      pdfVenta,
      pdfProd,
    } = this.state;

    this.setState({
      isActive: true,
    });

    const consultaUno = proforma.includes(prof);

    if (oldProf === prof || !consultaUno) {
      if (oldProf !== prof) {
        notification.success({
          message: "Factura Actualizada",
          description: `La FP "${oldProf}" se cambió a "${prof}" con éxito.`,
          top: 80,
        });
      }

      message.loading({ content: "Actualizando registro...", key: 'updating_comercial' });
      const opName = selectedOption.label;

      const fechaEntregaFormat = moment(fechaEntrega).format("DD/MM/YYYY");
      const NfechaIngresoFormat = moment(fechaIngreso).format("DD/MM/YYYY");

      const opWithPrice =
        this.state.filelistVenta && this.state.filelistVenta.length
          ? this.state.filelistVenta[0].xhr.url
          : pdfVenta;

      const okWithoutPrice =
        this.state.filelistProd && this.state.filelistProd.length
          ? this.state.filelistProd[0].xhr.url
          : pdfProd;


      // Map swifts for database
      const dbSwifts = this.state.swifts.map(s => ({
        name: s.name,
        url: s.url
      }));

      // Legacy fields mapping
      const sw30furl = this.state.swifts[0]?.url || "";
      const sw70furl = this.state.swifts[1]?.url || "";
      const swift30name = sw30furl ? "30" : "";
      const swift70name = sw70furl ? "70" : "";

      const data = {
        cFechaEntrega: fechaEntregaFormat || "",
        cliente: opName || "",
        prof: prof || "",
        cFechaIngreso: NfechaIngresoFormat || "",
        a: [opWithPrice || ""],
        profsp: [okWithoutPrice || ""],
        sw30Files: [sw30furl || ""],
        sw70Files: [sw70furl || ""],
        sw30: swift30name,
        sw70: swift70name,
        swifts: dbSwifts,
      };

      try {
        await this.ref.doc(doc).update(data);
        
        // Update complementary collection
        if (pcpvalue) {
          const ingRef = firebase.firestore().collection("ing").doc(String(pcpvalue));
          const ingDoc = await ingRef.get();
          if (ingDoc.exists) {
            let pcp = ingDoc.data();
            pcp.cFechaIngreso = NfechaIngresoFormat || "";
            pcp.prof = prof || "";
            pcp.a = [okWithoutPrice || ""];
            pcp.cliente = opName || "";
            pcp.cFechaEntrega = fechaEntregaFormat || "";
            pcp.estado = [pcp.estado[0], prof];
            await ingRef.update(pcp);
          }
        }

        message.destroy();
        notification.success({
          message: "Actualización Exitosa",
          description: "El registro comercial se ha actualizado correctamente.",
          top: 80,
        });
        this.props.history.push("/comercial/Procesos");
      } catch (error) {
        message.destroy();
        console.error(error.message);
        message.error(`Error: ${error.message}`);
        this.setState({ isActive: false });
      }
    } else {
      notification.error({
        message: "Error de Validación",
        description: `La FACTURA PROFORMA "${prof}" ya existe.`,
        top: 80,
      });
      this.setState({ isActive: false });
    }
  };

  render() {
    const { prof, selectedOption, fechaEntrega, loading, isActive, uploading } = this.state;

    const isUploading = 
      (this.state.filelistVenta && this.state.filelistVenta.some(f => f.status === 'uploading')) ||
      (this.state.filelistProd && this.state.filelistProd.some(f => f.status === 'uploading')) ||
      (this.state.filelistsw30 && this.state.filelistsw30.some(f => f.status === 'uploading')) ||
      (this.state.filelistsw70 && this.state.filelistsw70.some(f => f.status === 'uploading'));

    const isInvalid = !selectedOption || !prof || !fechaEntrega || isUploading;

    const uploadButton = (
      <Button icon={<Icon type={loading ? "loading" : "plus"} />} className="ant-btn-upload">
        Subir Archivo
      </Button>
    );

    const handleState = (fileListSw, secondaryFileListSw, info) => {
      const infofileList = [...info.fileList];
      if (info.fileList.length > 1) {
        infofileList.splice(0, 1);
      }
      const fileResponse = infofileList.map((file) => {
        if (file.response) {
          file.url = file.response.url;
        }
        return file;
      });

      this.setState({
        [fileListSw]: info.fileList,
        [secondaryFileListSw]: fileResponse,
      });
    };

    const handleLoadingState = (l) => {
      this.setState({ loading: l });
    };

    const handleUploadfile = (file, nameState) => {
      this.setState({
        [nameState]: file.name.split(".")[0],
      });
    };

    return (
      <div className="content edit-comercial-register">
        <Row>
          <Col md={10} lg={8} className="ml-auto mr-auto">
            <Card className="card-user">
              <CardHeader>
                <CardTitle>ACTUALIZAR REGISTRO</CardTitle>
              </CardHeader>
              <CardBody style={{ padding: '30px' }}>
                <form onSubmit={this.onSubmit}>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label className="form-group-label" for="cliente">CLIENTE</Label>
                        <Select
                          placeholder="Seleccionar Cliente"
                          onChange={this.selectHandleChange}
                          name="cliente"
                          value={selectedOption}
                          required
                          isSearchable={true}
                          options={this.state.clientes}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label className="form-group-label" for="prof">FACTURA PROFORMA</Label>
                        <Input
                          type="text"
                          name="prof"
                          id="prof"
                          value={prof}
                          onChange={this.onChange}
                          autoComplete="off"
                          required
                          disabled
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label className="form-group-label" for="fechaEntrega">FECHA DESPACHO</Label>
                        <DatePicker
                          style={{ width: '100%', height: '42px' }}
                          value={fechaEntrega ? moment(fechaEntrega) : null}
                          onChange={this.handleChange2}
                          format="DD/MM/YYYY"
                          locale={locale}
                          placeholder="Seleccionar fecha"
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <div className="upload-grid mt-4">
                    <Row>
                      <Col md={6}>
                        <div className="upload-section">
                          <Label className="upload-label">
                            <Icon type="file-text" style={{ marginRight: '8px', color: '#1890ff' }} />
                            FACTURA PROFORMA CON PRECIO
                          </Label>
                          <Upload
                            onRemove={() => this.setState({ filelistVenta: null })}
                            accept={".pdf"}
                            multiple={false}
                            onChange={(info) => handleChangeSwift(info, "filelistVenta", "fileListVentas", handleState, handleLoadingState)}
                            customRequest={({ onError, onSuccess, file }) =>
                              customUploadSwift({
                                onError, onSuccess, file,
                                folder: "profVenta",
                                stateList: this.state.proforma,
                                nameState: "prof",
                                handleUploadfile,
                                notification
                              })
                            }
                            fileList={this.state.fileListVentas}
                          >
                            {uploadButton}
                          </Upload>
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="upload-section">
                          <Label className="upload-label">
                            <Icon type="file-done" style={{ marginRight: '8px', color: '#52c41a' }} />
                            FACTURA PROFORMA SIN PRECIO
                          </Label>
                          <Upload
                            onRemove={() => this.setState({ filelistProd: null })}
                            accept={".pdf"}
                            multiple={false}
                            onChange={(info) => handleChangeSwift(info, "filelistProd", "fileListProduc", handleState, handleLoadingState)}
                            customRequest={({ onError, onSuccess, file }) =>
                              customUploadSwift({
                                onError, onSuccess, file,
                                folder: "profProd",
                                stateList: this.state.proforma,
                                nameState: "prof",
                                handleUploadfile,
                                notification
                              })
                            }
                            fileList={this.state.fileListProduc}
                          >
                            {uploadButton}
                          </Upload>
                        </div>
                      </Col>
                    </Row>

                    <Row>
                      {this.state.swifts.map((swift, index) => (
                        <Col md={6} key={index}>
                          <div className="upload-section">
                            <Label className="upload-label">
                              <Icon type="dollar" style={{ marginRight: '8px', color: '#faad14' }} />
                              {`SWIFT DE TRANSFERENCIA ${index + 1}`}
                            </Label>
                            <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
                              <div style={{ flex: 1 }}>
                                <Upload
                                  onRemove={() => {
                                    const newSwifts = [...this.state.swifts];
                                    newSwifts[index].url = "";
                                    newSwifts[index].fileList = [];
                                    this.setState({ swifts: newSwifts });
                                  }}
                                  accept={".pdf, .jpeg, .jpg, .png, .img, tiff, .bmp"}
                                  multiple={false}
                                  onChange={(info) => this.handleSwiftChange(index, info)}
                                  customRequest={({ onError, onSuccess, file }) =>
                                    customUploadSwift({
                                      onError, onSuccess, file,
                                      folder: "swComercial",
                                      stateList: [],
                                      nameState: `swift_${index}`,
                                      notification
                                    })
                                  }
                                  fileList={swift.fileList}
                                >
                                  {uploadButton}
                                </Upload>
                              </div>
                              {this.state.swifts.length > 1 && (
                                <Button 
                                  type="danger" 
                                  shape="circle"
                                  icon="delete" 
                                  size="small"
                                  onClick={() => this.removeSwift(index)}
                                  style={{ marginTop: '5px' }}
                                />
                              )}
                            </div>
                          </div>
                        </Col>
                      ))}
                    </Row>
                    <div className="mt-2 mb-4">
                      <Button 
                        type="dashed" 
                        onClick={this.addSwift} 
                        icon="plus" 
                        style={{ width: '100%', height: '42px', borderRadius: '8px' }}
                      >
                        Agregar Pago / SWIFT
                      </Button>
                    </div>
                  </div>

                  <div className="text-center mt-5">
                    <Button
                      type="primary"
                      className="btn-submit"
                      onClick={this.onSubmit}
                      loading={isActive}
                      disabled={isActive || uploading || isInvalid}
                    >
                      ACTUALIZAR REGISTRO
                    </Button>
                  </div>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default EditComercialRegister;
